// import store from '../store';

export default class Resubmission {
  constructor(api) {
    this.api = api
  }

  create({address_id, owner_id, notice, resub_date, active}) {
    return this.api.call_busy({
      '_class': 'Resubmission',
      '_method': 'create',
      'address_id': address_id,
      'owner_id': owner_id,
      'notice': notice,
      'resub_date': resub_date,
      'active': active,
    })
  }

  update({id, address_id, owner_id, notice, resub_date, active}) {
    return this.api.call_busy({
      '_class': 'Resubmission',
      '_method': 'update',
      'id': id,
      'address_id': address_id,
      'owner_id': owner_id,
      'notice': notice,
      'resub_date': resub_date,
      'active': active,
    })
  }

  active({id, active}) {
    return this.api.call_busy({
      '_class': 'Resubmission',
      '_method': 'update',
      'id': id,
      'active': active,
    })
  }

  delete(id) {
    return this.api.call_busy({
      '_class': 'Resubmission',
      '_method': 'delete',
      'id': id,
    })
  }

}